import { serializable, primitive } from 'serializr';

export class Sector {
  @serializable(primitive())
  id?: number;

  @serializable(primitive())
  name?: string;
}
